namespace Solovis.InvDataSelectors {

    export class ContactSelectorControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public selectionCallback;
        public cancelCallback;
        public searchBox: JQuery;

        constructor(options) {
            super(options);

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;
        }


        public doInit() {
        }

        public doRender() {
            var self = this;

            let findItems = (autocompleteRequest, responseCallback) => {
                this._portalServices.rpc().invoke("~/Selectors/ContactSelector/FindContact", { filterText: autocompleteRequest.term, maxItems: 10 },
                    function (response, success) {
                        if (success) {
                            responseCallback(response.result);
                        }
                        else {
                            // TODO: report error somehow
                            responseCallback([]);
                        }
                    });
            }

            this.searchBox = $("<input>").attr("type", "text").appendTo(this.container);

            (this.searchBox as any).autocomplete({
                minLength: 1,
                source: findItems,
                focus: function (event, ui) {
                    if (ui.item)
                        self.searchBox.val(ui.item.label);
                    return false;
                },
                select: function (event, ui) {
                    if (ui.item) {
                        self.searchBox.val(ui.item.label);
                        var item = ui.item;

                        if (self.selectionCallback) {
                            self.selectionCallback(item);
                        }
                    }
                    return false;
                }
            })
                .data("ui-autocomplete")._renderItem = function (ul, item) {
                    var label = item.label;

                    var itemLink = $("<a>").text(label);
                    var itemElement = $("<li>").append(itemLink);
                    itemElement.appendTo(ul);
                    return itemElement;
                };

            // Trigger cancel when escape is pressed.
            $(this.searchBox).keyup(function (e) {
                if (e.keyCode == 27) {
                    // Escape was pressed.
                    if (self.cancelCallback) {
                        self.cancelCallback();
                    }
                }
            });
        }

        public focus() {
            if (this.searchBox) {
                this.searchBox.focus();
            }
        }
    }
    
}


    
